import * as React from 'react';
import cn from 'classnames';

import { useTheme } from '../../../../../theme';
import { BaggageType } from '@websky/graphql';
import BaggageIcon from '../../../../../Cart/BaggageIcon/BaggageIcon';
import { CdnIcon } from '@shared/ui';
import { useRenderers } from '../../../../../renderProps';

interface Props {
	className?: string;
	rfics?: string;
	icon?: React.ReactNode;
	baggageType?: BaggageType;
	isActive?: boolean;
	isSelected?: boolean;
	onClick?: () => void;
}

const HeaderEquipmentItem: React.FC<Props> = ({
	className,
	rfics,
	icon,
	baggageType,
	isActive,
	isSelected,
	onClick
}) => {
	const { HeaderEquipmentItem: css } = useTheme('UpgradeBaggageDialog');

	const { renderBaggageHeaderIcon: BaggageHeaderIconOverride } = useRenderers();

	const baggageIcon = <BaggageIcon className={css.icon} rfisc={rfics} baggageType={baggageType} />;

	return (
		<div
			className={cn(className, css.wrapper, {
				[css.wrapper_pointer]: !!onClick,
				[css.active]: isActive
			})}
			onClick={onClick}
		>
			{isSelected && <div className={css.selected}>{<CdnIcon icon={'Info/Choosed'} />}</div>}
			{icon ??
				(BaggageHeaderIconOverride ? (
					<BaggageHeaderIconOverride rfics={rfics} isActive={isActive}>
						{baggageIcon}
					</BaggageHeaderIconOverride>
				) : (
					baggageIcon
				))}
		</div>
	);
};

export default HeaderEquipmentItem;
